export const ApiErrorKind = {
  server: 'server',
  client: 'client',
  network: 'network',
} as const
export type ApiErrorKind = (typeof ApiErrorKind)[keyof typeof ApiErrorKind]

// 伏せ字・要約・切り詰め済みの文字列（summarizePayload）
export type ApiErrorDetails = {
  requestQuery?: string
  requestBody?: string
  responseBody?: string
}

export type ApiErrorEntry = {
  kind: ApiErrorKind
  statusCode?: number
  method: string
  path: string
  serverMessage?: string
  details: ApiErrorDetails
  observedAt: string // client が観測した時刻
  route: string
}
